import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { titleDiv, titleName } from '../../styles';

function Title(props) {
  const { t } = useTranslation();
  return (
    <div style={titleDiv}>
      <div style={titleName}>{t(props.title)}</div>
    </div>
  );
}

Title.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Title;
